import { useEffect, useState } from 'react';
import { Page } from '../../hooks/usePage';
import './TaskList.css';
import { TaskModel } from '../../api/models/task/taskmodel';
import Task from './Task';
import EditTaskDialog from './EditTask';
import { clearTaskCompletions, completeTask, deleteTask, newTask, saveTask } from '../../api/API';
import { filterCompletionsThisWeek } from '../../util/DateUtil';

type TaskListProps = {
    page: Page;
};

const TaskList = ({ page }: TaskListProps) => {
    const { tasks, isOwner: admin, pageInfo, reloadTasks } = page;

    const [show, setShow] = useState<boolean>(false);
    const [sortedTasks, setSortedTasks] = useState<TaskModel[]>([]);
    const [editing, setEditing] = useState<TaskModel | null>(null);

    const updateSortedTasks = () => {
        // Sort tasks by reward points, descending
        const sorted = [...tasks].sort((a, b) => b.reward.points - a.reward.points);
        setSortedTasks(sorted);
    };

    useEffect(() => {
        updateSortedTasks();
    }, [tasks]);

    const onTaskSelect = (task: TaskModel) => {
        if (!window.confirm(`Are you sure you want to complete ${task.name}?`)) return;

        completeTask(pageInfo.url, task.id).then((res) => {
            if (!res || !isNaN(+res)) {
                alert("Failed to complete task. Check logs & try again later.");
                return;
            }

            reloadTasks();
        }).catch((err) => {
            console.error("Failed to complete task:", err);
            alert("Failed to complete task. Check logs & try again later.");
        });
    }

    return (
        <>
            <div id="tasks">
                <div className="header">
                    <h3>Tasks</h3>
                    <button onClick={() => !show ? setShow(true) : setShow(false)}>{show ? "Hide" : "Show"} Tasks</button>
                </div>
                {show && <div className={"list"}>
                    {sortedTasks.map((task) => (
                        <Task
                            key={task.id}
                            task={task}
                            completions={page.taskCompletions.filter(tc => tc.task_id === task.id).length}
                            completionsThisWeek={filterCompletionsThisWeek(page.taskCompletions.filter(tc => tc.task_id === task.id)).length}
                            admin={admin}
                            onSelect={admin ? () => setEditing(task) : () => onTaskSelect(task)}
                        />
                    ))}

                    {admin && <div className="task add" onClick={() => setEditing({} as TaskModel)}>
                        <div className="icon">+</div>
                    </div>}
                </div>}
                {editing && <EditTaskDialog task={editing} save={async (task: any): Promise<boolean> => {
                    const res = await (async () => {
                        if (task.id === undefined) {
                            return await newTask(pageInfo.url, task);
                        } else {
                            return await saveTask(pageInfo.url, task);
                        }
                    })();

                    if (!res || !isNaN(+res)) {
                        alert("Failed to save. Check logs & try again later.");
                        return false;
                    }

                    setEditing(null);
                    reloadTasks();
                    return true;
                }}
                    del={async (task: any): Promise<boolean> => {
                        const res = await deleteTask(pageInfo.url, task.id);

                        if (!res || !isNaN(+res)) {
                            alert("Failed to delete. Check logs & try again later.");
                            return false;
                        }

                        setEditing(null);
                        reloadTasks();
                        return true;
                    }}
                    clearCompletions={async (task: any): Promise<boolean> => {
                        const res = await clearTaskCompletions(pageInfo.url, task.id);

                        if (!res || !isNaN(+res)) {
                            alert("Failed to clear completions. Check logs & try again later.");
                            return false;
                        }

                        setEditing(null);
                        reloadTasks();
                        return true;
                    }}
                    close={() => setEditing(null)} />}
            </div>
        </>
    );
}

export default TaskList;